<!-- Ad Banner Start -->
<div class="container-fluid mb-4" *ngIf="bannerGroup ? dynamicBanners.length > 0 : (adImageOne || adImageTwo)">
  <div class="ad_banners">
    <ng-container *ngIf="bannerGroup && dynamicBanners.length > 0; else staticBanners">
      <a class="banner_div" *ngFor="let banner of dynamicBanners"
         [routerLink]="banner.url ? [banner.url] : []">
        <img [src]="banner.image" class="img-fluid" alt="" />
      </a>
    </ng-container>
    <ng-template #staticBanners>
      <a class="banner_div" [routerLink]="[adLinkOne]">
        <img [src]="adImageOne" class="img-fluid" alt="" />
      </a>
      <a class="banner_div" [routerLink]="[adLinkTwo]">
        <img [src]="adImageTwo" class="img-fluid" alt="" />
      </a>
    </ng-template>
  </div>
</div>
<!-- Ad Banner End -->
